/* eslint-disable */
//tslint:disable

import { IAvailableJksSchema } from './AvailableJksSchema';
import { IBankSchema } from './BankSchema';
import { IFeatureSchema } from './FeatureSchema';
import { IMortgageParamsSchema } from './MortgageParamsSchema';

export interface IPromoInfoSchema {
  /** Логотип застройщика/агента **/
  authorLogoUrl?: string | null;
  /** Название (имя) застройщика/агента **/
  authorName?: string | null;
  /** Realty user id, разместившего акцию **/
  authorRealtyUserId?: number | null;
  /** Список ЖК в которых доступна акция **/
  availableJks?: IAvailableJksSchema[] | null;
  /** Банк - автор **/
  bank?: IBankSchema | null;
  /** Список Банков **/
  banks?: IBankSchema[] | null;
  /** ID компании, разместившей акцию **/
  companyId?: number | null;
  /** Описание акции **/
  description?: string | null;
  /** Срок действия акции **/
  end?: string | null;
  /** Особенности акции **/
  features?: IFeatureSchema[] | null;
  /** Акция от банка **/
  isFromBank?: boolean | null;
  /** Акция от застройщика **/
  isFromBuilder?: boolean | null;
  /** Параметры акции по ипотеке **/
  mortgageParams?: IMortgageParamsSchema | null;
  /** Название акции **/
  name: string;
  /** ID Акции. Deprecated (используй unique_promo_id) **/
  promoId: number;
  /** Изображение для акции **/
  promoImage?: string | null;
  /** Источник акции (застройщик/представитель) **/
  promoSource?: string | null;
  /** Тип акции **/
  promoType: EPromoType;
  /** Дата начала действия акции **/
  start?: string | null;
  /** Подзаголовок акции **/
  subtitle?: string | null;
  /** ID Акции **/
  uniquePromoId: string;
}

export enum EPromoType {
  /** Акция от банка **/
  Bank = 'bank',
  /** Бонусы **/
  Bonus = 'bonus',
  /** Циан ипотека **/
  CianMortgage = 'cianMortgage',
  /** Скидки **/
  Discount = 'discount',
  /** Материнский капитал **/
  MaternalCapital = 'maternalCapital',
  /** Военная ипотека **/
  MilitaryMortgage = 'militaryMortgage',
  /** Ипотека **/
  Mortgage = 'mortgage',
}
